import { createSlice } from "@reduxjs/toolkit";

const searchSlice = createSlice({
  name: "searchText",
  initialState: "",
  reducers: {
    handleSearchTextChange(state, action) {
      return action.payload;
    },
    resetSearchText() {
      return "";
    },
  },
});

export const { handleSearchTextChange, resetSearchText } = searchSlice.actions;
export default searchSlice.reducer;
